export default "__VITE_ASSET__D6WmwEeF__"